export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-6.a4213534.png";